import styled from 'styled-components';

export const MembersDiv = styled.div`
	width: 100%;
	display: flex;
	flex-direction: 'row';
	flex-wrap: wrap;
	justify-content: center;
	transition: all 500ms ease-in;
`;
